import {Injectable} from "@angular/core";
import {Apollo} from "apollo-angular";
import {LocalizationCodeGqlModel} from "./localization-code.gql-model";

@Injectable()
export class LocalizationCodeService {
  constructor(
    private apollo: Apollo,
  ) {}

  async getLocalizationCode(localizationCode: string): Promise<LocalizationCodeGqlModel> {
    const query = LocalizationCodeGqlModel.query;
    const variables = LocalizationCodeGqlModel.variables(localizationCode);

    return this.apollo.query({query, variables, fetchPolicy: "no-cache"})
      .pipe(LocalizationCodeGqlModel.mapper)
      .toPromise();
  }
}
